// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
// @ components
const EarlyCancelSimulationView = require('components/imposition/earlyCancelSimulation/earlyCancelSimulationView');
// @ actions
const impositionEarlyCancelActions = require('actions/contactCenter/impositionEarlyCancellation');
const depositsActions = require('actions/deposits');

class ImpositionEarlyCancelSimulationContainer extends React.Component {
    render () {
        return (
            <EarlyCancelSimulationView
                {...this.props}
            />
        );
    }
}

ImpositionEarlyCancelSimulationContainer.propTypes = {
    immImpositionEarlyCancellationData: PropTypes.object.isRequired,
    immDeposits: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    queryImpositionEarlyCancellationData: PropTypes.func,
    match: PropTypes.object.isRequired,
    requestDeposits: PropTypes.func.isRequired,
    requestInterveners: PropTypes.func.isRequired,
};

module.exports.constructor = ImpositionEarlyCancelSimulationContainer;
module.exports.ImpositionEarlyCancelSimulationContainer = connect(state => ({
    immImpositionEarlyCancellationData: state.impositionEarlyCancellation,
    immDeposits: state.deposits,
    immAccounts: state.accounts,
}), {
    queryImpositionEarlyCancellationData: impositionEarlyCancelActions.queryImpositionEarlyCancellationData,
    requestDeposits: depositsActions.requestDeposits,
    requestInterveners: depositsActions.requestDepositInterveners,
})(ImpositionEarlyCancelSimulationContainer);
